import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MdArrowBack } from 'react-icons/md';
import { LanguageSelector, useLanguage } from '../i18n';
import { API_BASE, withSystem, localizedField, SYSTEM_SLUG } from './publicApi';

// Moved off the homepage (PublicBooking.js) so the homepage itself stays a
// short, two-screen scroll. Privacy Policy and Terms of Service used to be
// a section at the bottom of the homepage, shown only when the admin had
// filled one in (Settings > Homepage Editor) — now each is its own route,
// linked from the footer, so it never adds to the homepage's length.
export default function LegalPage({ type }) {
    const { language, t } = useLanguage();
    const [homepage, setHomepage] = useState(null);

    useEffect(() => {
        axios.get(`${API_BASE}/homepage`, { params: withSystem() }).then(response => {
            setHomepage(response.data);
        }).catch(() => { });
    }, []);

    const title = type === 'terms' ? t('legal.termsTitle') : t('legal.privacyTitle');
    const content = localizedField(homepage, type === 'terms' ? 'terms_of_service' : 'privacy_policy', language);

    return (
        <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Inter',-apple-system,sans-serif" }}>
            <nav style={{
                background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 5%', height: 68,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'sticky', top: 0, zIndex: 200, boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <img src={homepage?.logo_url || '/logo512.png'} alt={`${homepage?.system_name || 'MITI FMS'} ${t('legal.logoAlt')}`} style={{ width: 38, height: 38, borderRadius: 9, objectFit: 'cover' }} />
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', lineHeight: 1 }}>{homepage?.system_name || 'MITI FMS'}</div>
                        {!SYSTEM_SLUG && <div style={{ fontSize: 10, color: '#94a3b8', letterSpacing: '0.5px' }}>{t('legal.facilityManagementLabel')}</div>}
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <LanguageSelector style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 8px' }} />
                    <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#2563eb', fontWeight: 600, textDecoration: 'none', border: '1.5px solid #2563eb', padding: '7px 16px', borderRadius: 8 }}>
                        <MdArrowBack size={15} /> {t('legal.backToHome')}
                    </a>
                </div>
            </nav>

            <section style={{ padding: '64px 5% 80px' }}>
                <div style={{ maxWidth: 760, margin: '0 auto' }}>
                    <h1 style={{ color: '#0f172a', fontSize: 32, fontWeight: 800, marginBottom: 20 }}>{title}</h1>
                    {content
                        ? <div style={{ color: '#475569', whiteSpace: 'pre-wrap', lineHeight: 1.7, fontSize: 15 }}>{content}</div>
                        : <p style={{ color: '#94a3b8' }}>{t('legal.notFilledIn')}</p>}
                </div>
            </section>

            <footer style={{ background: '#0f172a', color: '#94a3b8', padding: '24px 5%', textAlign: 'center', fontSize: 13 }}>
                © {new Date().getFullYear()} {homepage?.system_name || 'MITI FMS'}. {t('legal.footerRights')}
            </footer>
        </div>
    );
}
